const valueWithPrecision = (value:any = 0, precision:any = 0) => {
	let newValue = '0';

	if (String(value).split('.')[1] && String(value).split('.')[1].length) {
		if (String(value).split('.')[1].length > precision) {
			let cutValue = String(value).split('.')[1].split('').slice(0, precision).join('');
			newValue = `${String(value).split('.')[0]}.${cutValue}`;
		} else {
			if (String(value).split('.')[1].length < precision) {
				newValue = String(value).padEnd(precision, '0');
			} else {
				newValue = String(value);
			}
		}
	} else {
		newValue = String(Number(value).toFixed(precision));
	}

	return newValue;
}

export default valueWithPrecision;